$(document).ready(function () {
    const $desktopDiscover = $('.header-navigation-discover')
      .not('.discover-mobile-cont .header-navigation-discover')
      .first();
    const $menuItems = $('.header-navigation .menu-lv-item');

    function isDesktop() {
      return window.innerWidth >= 1024;
    }

    function closeMobilePanel(panel) {
      const $panel = $(panel);
      const activeClass = $panel.data('mobile-panel-active-class');

      if (activeClass) {
        $panel.removeClass(activeClass);
      }

      $('body').removeClass('menu_open_mb');

      const panelHost = $panel.closest('[data-mobile-panel-host]');
      if (panelHost.length) {
        window.setTimeout(function () {
          if (!$panel.hasClass(activeClass) && !$('body').hasClass('menu_open_mb')) {
            panelHost.empty();
          }
        }, 550);
      }
    }

    function showDiscoverMenu() {
      $desktopDiscover.css({
        opacity: '1',
        'max-height': 'fit-content',
        'border-top': '1px solid #D4D4D8',
        'border-bottom': '1px solid #D4D4D8'
      });
    }

    function hideDiscoverMenu() {
      $desktopDiscover.css({
        opacity: '0',
        'max-height': '0',
        'border-top': 'none',
        'border-bottom': 'none'
      });
    }

    function getCarouselState(carouselEl) {
      if (!carouselEl) return null;

      const track = carouselEl.querySelector('.discover-active-track');
      const pagination = carouselEl.querySelector('.discover-carousel-pagination');
      const slides = track ? Array.prototype.slice.call(track.querySelectorAll('.discover-active-slide')) : [];

      if (!track || !pagination || !slides.length) return null;

      return { track, pagination, slides };
    }

    function getClosestSlideIndex(track, slides) {
      let closestIndex = 0;
      let closestDistance = Infinity;

      slides.forEach(function (slide, index) {
        const distance = Math.abs(slide.offsetLeft - track.scrollLeft);

        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return closestIndex;
    }

    function setActiveCarouselBullet(carouselEl) {
      const state = getCarouselState(carouselEl);
      if (!state) return;

      const activeIndex = getClosestSlideIndex(state.track, state.slides);
      const bullets = state.pagination.querySelectorAll('.discover-carousel-bullet');

      bullets.forEach(function (bullet, index) {
        bullet.classList.toggle('is-active', index === activeIndex);
      });
    }

    function initNativeCarouselByElement(carouselEl) {
      const state = getCarouselState(carouselEl);
      if (!state) return;

      state.pagination.innerHTML = '';

      state.slides.forEach(function (slide, index) {
        const bullet = document.createElement('button');
        bullet.type = 'button';
        bullet.className = 'discover-carousel-bullet';
        bullet.setAttribute('aria-label', 'Go to Discover item ' + (index + 1));

        bullet.addEventListener('click', function () {
          state.track.scrollTo({
            left: slide.offsetLeft,
            behavior: 'smooth'
          });
        });

        state.pagination.appendChild(bullet);
      });

      if (!state.track.dataset.nativeCarouselBound) {
        state.track.dataset.nativeCarouselBound = 'true';
        state.track.addEventListener('scroll', function () {
          window.requestAnimationFrame(function () {
            setActiveCarouselBullet(carouselEl);
          });
        }, { passive: true });
      }

      setActiveCarouselBullet(carouselEl);
    }

    function initDesktopCarousel() {
      $desktopDiscover.find('.discover-active-cont-list').each(function () {
        initNativeCarouselByElement(this);
      });
    }

    function initMobileCarousel() {
      $('.discover-mobile-cont').find('.discover-active-cont-list').each(function () {
        initNativeCarouselByElement(this);
      });
    }

    function initMobileCarouselByPanel(panel) {
      $(panel).find('.discover-active-cont-list').each(function () {
        initNativeCarouselByElement(this);
      });
    }

    function triggerMobileCarouselInit() {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          initMobileCarousel();
        });
      });
    }

    function bindDesktopSupportHover() {
      if (!isDesktop()) {
        return;
      }

      $('.header-navigation .menu-lv-item').off('mouseenter.blacklyteSupport mouseleave.blacklyteSupport');
      $('.newsupport-mobile-cont').off('mouseleave.blacklyteSupport');

      $('.header-navigation .menu-lv-item').on('mouseenter.blacklyteSupport', function () {
        const currentMenuText = $(this).text().toLowerCase().trim();

        if (currentMenuText === 'support') {
          $('.newsupport-mobile-cont').css({
            opacity: 1,
            left: $(this).offset().left - 40,
            'max-height': 'fit-content',
            border: '1px solid #D4D4D8'
          });
        } else {
          $('.newsupport-mobile-cont').css({
            opacity: 0,
            left: 0,
            'max-height': 0,
            border: 'none'
          });
        }
      });

      $('.newsupport-mobile-cont').on('mouseleave.blacklyteSupport', function () {
        $(this).css({
          opacity: '0',
          left: 0,
          'max-height': 0,
          border: 'none'
        });
      });

      $('.header-navigation .menu-lv-item').on('mouseleave.blacklyteSupport', function () {
        if ($(this).text().toLowerCase().trim() === 'support' && !$('.newsupport-mobile-cont:hover').length) {
          $('.newsupport-mobile-cont').css({
            opacity: '0',
            'max-height': '0',
            border: 'none'
          });
        }
      });
    }

    function bindDesktopDiscoverHover() {
      $menuItems.off('mouseenter.blacklyteDiscover mouseleave.blacklyteDiscover');
      $desktopDiscover.off('mouseleave.blacklyteDiscover');

      if (!isDesktop()) {
        hideDiscoverMenu();
        return;
      }

      $menuItems.on('mouseenter.blacklyteDiscover', function () {
        const currentMenuText = $(this).text().toLowerCase().trim();

        if (currentMenuText === 'discover') {
          showDiscoverMenu();
          initDesktopCarousel();
        } else {
          hideDiscoverMenu();
        }
      });

      $menuItems.on('mouseleave.blacklyteDiscover', function () {
        const currentMenuText = $(this).text().toLowerCase().trim();

        if (currentMenuText === 'discover' && !$desktopDiscover.is(':hover')) {
          hideDiscoverMenu();
        }
      });

      $desktopDiscover.on('mouseleave.blacklyteDiscover', function () {
        hideDiscoverMenu();
      });
    }

    $(document).off('click.blacklyteMobilePanelClose').on('click.blacklyteMobilePanelClose', '[data-mobile-panel-close]', function (event) {
      event.preventDefault();
      event.stopPropagation();
      closeMobilePanel($(this).closest('.header-mobile-panel'));
    });

    $(document).off('click.blacklyteMobileUrl').on('click.blacklyteMobileUrl', '[data-mobile-url]', function () {
      const url = $(this).data('mobile-url');

      if (url) {
        window.location.href = url;
      }
    });

    $(document).off('click.blacklyteMobileHref').on('click.blacklyteMobileHref', '[data-mobile-href]', function (event) {
      const url = $(this).data('mobile-href');

      event.preventDefault();
      event.stopPropagation();

      if (url) {
        window.location.href = url;
      }
    });

    bindDesktopSupportHover();
    bindDesktopDiscoverHover();

    window.addEventListener('resize', function () {
      bindDesktopSupportHover();
      bindDesktopDiscoverHover();

      $('.header-navigation-discover .discover-active-cont-list').each(function () {
        initNativeCarouselByElement(this);
      });
    });

    $('.discover-mobile-cont').each(function () {
      const mobileDiscoverPanel = this;

      if (!('MutationObserver' in window)) {
        return;
      }

      const mobileObserver = new MutationObserver(function () {
        if ($(mobileDiscoverPanel).hasClass('discover-mobile-cont-active')) {
          setTimeout(function () {
            initMobileCarouselByPanel(mobileDiscoverPanel);
          }, 100);
          setTimeout(function () {
            initMobileCarouselByPanel(mobileDiscoverPanel);
          }, 300);
          setTimeout(function () {
            initMobileCarouselByPanel(mobileDiscoverPanel);
          }, 600);
        }
      });

      mobileObserver.observe(mobileDiscoverPanel, {
        attributes: true,
        attributeFilter: ['class']
      });
    });

    if ('MutationObserver' in window) {
      const bodyObserver = new MutationObserver(function () {
        if (document.body.classList.contains('menu_open_mb')) {
          setTimeout(triggerMobileCarouselInit, 100);
          setTimeout(triggerMobileCarouselInit, 300);
          setTimeout(triggerMobileCarouselInit, 600);
        }
      });

      bodyObserver.observe(document.body, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    $(document).off('transitionend.blacklyteDiscoverMobile webkitTransitionEnd.blacklyteDiscoverMobile')
      .on('transitionend.blacklyteDiscoverMobile webkitTransitionEnd.blacklyteDiscoverMobile', '.discover-mobile-cont', function () {
        initMobileCarouselByPanel(this);
      });

    $(document).off('blacklyte:mobile-panel-open.blacklyteDiscoverMobile')
      .on('blacklyte:mobile-panel-open.blacklyteDiscoverMobile', function (event, data) {
        if (data && data.panelKey === 'discover' && data.panel) {
          setTimeout(function () {
            initMobileCarouselByPanel(data.panel);
          }, 100);
          setTimeout(function () {
            initMobileCarouselByPanel(data.panel);
          }, 300);
          setTimeout(function () {
            initMobileCarouselByPanel(data.panel);
          }, 600);
        }
      });

    $(document).off('click.blacklyteDiscoverMobile').on('click.blacklyteDiscoverMobile', function () {
      setTimeout(function () {
        if ($('.discover-mobile-cont.discover-mobile-cont-active').length) {
          triggerMobileCarouselInit();
        }
      }, 300);
    });
  });
